import type { ExplainBrainInput, ManagerExplanation } from './explainTypes';
import { selectExplainTemplate, scrubExplainText } from './explainTemplates';

function scrubList(items: string[]): string[] {
  return items.map(scrubExplainText).filter(Boolean);
}

/**
 * Explain Layer — AI 经纪人说明层
 *
 * 只读 CharacterOperation / MarketingDecision / PlatformDecision / TodayDecision。
 * 不重新判断、不生成素材、不改 Pipeline Decision。
 * 输出一律白话，不含工程字眼。
 */
export function buildManagerExplanation(input: ExplainBrainInput): ManagerExplanation {
  const { operation, marketing, platform, decision } = input;
  const template = selectExplainTemplate(marketing);
  const explanation = template(operation, marketing, platform, decision);

  // 保底：字段不得为空，且再 scrub 一次
  return {
    today_summary: scrubExplainText(explanation.today_summary || '今天按既有经营安排推进。'),
    today_goal: scrubExplainText(explanation.today_goal || '完成今日经营动作'),
    today_reason: scrubExplainText(
      explanation.today_reason ||
        [...operation.today_reason, ...marketing.promotion_reason].join('\n') ||
        '依据今天的经营安排推进。',
    ),
    today_usage: scrubExplainText(explanation.today_usage || '按今天的重点平台节奏发布并回覆互动。'),
    today_do: scrubList(explanation.today_do).length
      ? scrubList(explanation.today_do)
      : ['✓ 完成今日基础动作'],
    today_dont: scrubList(explanation.today_dont).length
      ? scrubList(explanation.today_dont)
      : ['✗ 不要偏离今日安排'],
    today_expected_result: scrubList(explanation.today_expected_result).length
      ? scrubList(explanation.today_expected_result)
      : ['维持稳定经营'],
    today_next_step: scrubExplainText(explanation.today_next_step || '观察今日反馈后再安排下一步。'),
    today_warning: scrubExplainText(explanation.today_warning || '请按今日建议推进，勿自行加码硬推。'),
    today_value: scrubExplainText(explanation.today_value || '今天的价值是把经营节奏稳住。'),
  };
}
